import type { MessageInstance } from "antd/es/message/interface";

let messageApi: MessageInstance | undefined;

export function bindNotifications(api: MessageInstance) {
  messageApi = api;

  return () => {
    if (messageApi === api) {
      messageApi = undefined;
    }
  };
}

function getMessageApi(): MessageInstance {
  if (!messageApi) {
    throw new Error("NotificationsBridge is not mounted");
  }

  return messageApi;
}

// Return void so saga call effects do not wait for the message to close.
export const notifications = {
  success: (content: string): void => {
    void getMessageApi().success(content);
  },
  error: (content: string): void => {
    void getMessageApi().error(content);
  },
};
